import { YZip } from 'utils/YupUtils';
import * as Yup from 'yup';

export const YExpertSearchDialog = Yup.object().shape({
  zip: YZip.required('PLZ ist erforderlich'),
});
